import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { agencyAccountManager } from 'root/src/shared/descriptions/endpoints/recordTypes';
import deleteAgencyAccountManagerPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/deleteAgencyAccountManagerPayloadSchema';
import { VALIDATE_TOKEN_ACCOUNT } from 'root/src/shared/descriptions/middlewares/middlewareIds';
import { agencyEndpointIds } from 'root/src/shared/agency/agency.constants';
export const deleteAgencyAccountManagerEndpoint = {
    [agencyEndpointIds.DELETE_AGENCY_ACCOUNT_MANAGER]: {
        authentication: authenticationTypes.authenticated,
        recordType: agencyAccountManager,
        authenticationRole: userGroups.agency,
        endpointType: otherEndpointType,
        payloadSchema: deleteAgencyAccountManagerPayloadSchema,
        middlewares: [VALIDATE_TOKEN_ACCOUNT],
        useRequestUserId: true,
    },
};
